import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './redux/store';
import App from './App';
//basename="/~alexgambleadmin" on Router
//PUBLIC_URL=/~alexgambleadmin npm run build
//import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root2'));
root.render(
  <Provider store={store} >
    <Router>
      <App />
    </Router>
  </Provider>
);
//reportWebVitals();